import styled, { keyframes } from 'styled-components'

const gradientAnimation = keyframes`
  0% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #27132C 40%, #220B3B 50%, #091921 60%, #0D0E12 100%);
  }
  10% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #26122B 40%, #200A3C 50%, #08171E 60%, #0D0E12 100%);
  }
  20% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #25112A 40%, #1F0A39 50%, #08171F 60%, #0D0E12 100%);
  }
  30% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #24102A 40%, #1E0937 50%, #07161F 60%, #0D0E12 100%);
  }
  40% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #231028 40%, #1D0936 50%, #07161E 60%, #0D0E12 100%);
  }
  50% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #26112B 40%, #1F0A39 50%, #08171F 60%, #0D0E12 100%);
  }
  60% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #25112A 40%, #1F0A39 50%, #08171F 60%, #0D0E12 100%);
  }
  70% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #27132C 40%, #220B3B 50%, #091921 60%, #0D0E12 100%);
  }
  80% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #27132C 40%, #220B3B 50%, #091921 60%, #0D0E12 100%);
  }
  90% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #26122B 40%, #200A3C 50%, #08171E 60%, #0D0E12 100%);
  }
  100% {
    background:
      linear-gradient(180deg, rgba(13, 14, 18, 0) 71.9%, #0D0E12 87.32%, #0D0E12 100%),
      radial-gradient(90.85% 145.34% at 50% 50%,
        #0D0E12 0%, #0D0E12 30%, #27132C 40%, #220B3B 50%, #091921 60%, #0D0E12 100%);
  }
`

const DarkGradientSection = styled.section`
  background: linear-gradient(
      180deg,
      rgba(13, 14, 18, 0) 71.9%,
      #0d0e12 87.32%,
      #0d0e12 100%
    ),
    radial-gradient(
      90.85% 145.34% at 50% 49.89%,
      #0d0e12 0%,
      #0d0e12 31.5%,
      #27132c 42%,
      #220b3b 52%,
      #091921 63%
    );
  animation: ${gradientAnimation} 3s ease-in-out infinite;
`

export default DarkGradientSection
